import React, { useEffect, useState } from 'react';
import './App.css';
import {Routes, Route } from 'react-router-dom';
import EventDetails from './components/events/EventDetailsPage';
import HomePage from './components/events/HomePage';
import PrivacyPolicy from './components/pages/PrivacyPolicy';
import AboutUs from './components/pages/AboutUs';
import ContactUs from './components/pages/ContactUs';
import Header from "./components/common/Header";
import Footer from "./components/common/Footer";
import TermCondition from './components/pages/TermCondition';
import { CityProvider } from "./components/context/CityContext";
import EventListingPage from "./components/events/EventListingPage";
import AllCategories from "./components/events/AllCategories";
import CreateEvent from "./components/events/createEvents/CreateEvent";
import CreateArtist from "./components/events/createEvents/CreateArtist";
import CreateVenue from "./components/events/createEvents/CreateVenue";
import PreviewEvent from "./components/events/createEvents/PreviewEvent";
import EventCreatedSuccess from "./components/events/createEvents/EventCreatedSuccess";


function App() {
return (
 <CityProvider>
 <div className="App">
  <Header />
    <div className="content">
      <Routes>
        <Route path="/" element={<HomePage />} />
        <Route path="/eventdetails/:id" element={<EventDetails />} />
        <Route path="/privacy" element={<PrivacyPolicy />} />
        <Route path="/terms" element={<TermCondition />} />
        <Route path="/events" element={<EventListingPage />} />
        <Route path="/categories" element={<AllCategories />} />
        <Route path="/CreateEvent" element={<CreateEvent />} />
        <Route path="/create-artist/:eventId" element={<CreateArtist />} />
        <Route path="/create-venue/:eventId" element={<CreateVenue />} />
        <Route path="/event-preview/:eventId" element={<PreviewEvent />} />
        <Route path="/event-created/:eventId" element={<EventCreatedSuccess />} />
         <Route path="/about-us" element={<AboutUs />} />
         <Route path="/contact-us" element={<ContactUs />} />
      </Routes>
      </div>
        <Footer />
 </div>
  </CityProvider>
  );
}

export default App;

